export const MasterModList = {
Haku: { 'MetaMod' : {Name: "SuffixLock", "Type": "Prefix", "Text": "SUFFIXES Cannot Be Changed", Cost: ['exalt', 2]}
},
Tora: { 'MetaMod' : {Name: "PrefixLock", "Type": "Suffix", "Text": "Prefixes Cannot Be Changed", Cost: ['exalt', 2]}
  }
}



// WEBPACK FOOTER //
// ./src/js/master-craft-mods.js